const invalidationTypes = Object.freeze({
    Suspended: 19,
});

export default invalidationTypes;
